import { render, staticRenderFns } from "./sendDialog.vue?vue&type=template&id=189139eb"
import script from "./sendDialog.vue?vue&type=script&lang=js"
export * from "./sendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports